__turbopack_context__.v({
  "filterBar": "AppsHeader-module__z8vdVG__filterBar",
  "midRow": "AppsHeader-module__z8vdVG__midRow",
});
